import { Component } from '@angular/core';
import { DATATYPE } from 'src/app/Enums/datatype';

@Component({
  selector: 'app-base-component',
  templateUrl: './base-component.component.html',
  styleUrls: ['./base-component.component.scss']
})
export class BaseComponentComponent{
  public displayProgressSpinner:boolean;
  public  isLoading: boolean;
  public claimName:string;
  public dataType: typeof DATATYPE = DATATYPE;
  constructor() { }

  public displaySpinner(){
    this.displayProgressSpinner = true;
  }
 
  public hideSpinner(){
    this.displayProgressSpinner = false; 
  }

  public startLoading(){
    this.isLoading = true;
  }
 
  public loaded(){
    this.isLoading = false;
  }
}
